'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.CoreXSelfExcludeDuration = exports.CoreXTimeOutDuration = void 0;
var CoreXTimeOutDuration;
(function (CoreXTimeOutDuration) {
    CoreXTimeOutDuration["TWENTYFOUR_HOURS"] = "PT24H";
    CoreXTimeOutDuration["SEVEN_DAYS"] = "P7D";
    CoreXTimeOutDuration["ONE_MONTH"] = "P30D";
    CoreXTimeOutDuration["SIX_WEEKS"] = "P42D";
    CoreXTimeOutDuration["THREE_MONTHS"] = "P90D";
})(CoreXTimeOutDuration = exports.CoreXTimeOutDuration || (exports.CoreXTimeOutDuration = {}));
var CoreXSelfExcludeDuration;
(function (CoreXSelfExcludeDuration) {
    CoreXSelfExcludeDuration["SIX_MONTHS"] = "P6M";
    CoreXSelfExcludeDuration["TWELVE_MONTHS"] = "P12M";
    CoreXSelfExcludeDuration["TWENTYFOUR_MONTHS"] = "P24M";
    CoreXSelfExcludeDuration["THIRTYSIX_MONTHS"] = "P36M";
    CoreXSelfExcludeDuration["SIXTY_MONTHS"] = "P60M";
    CoreXSelfExcludeDuration["INDEFINITELY"] = "0";
})(CoreXSelfExcludeDuration = exports.CoreXSelfExcludeDuration || (exports.CoreXSelfExcludeDuration = {}));
